<div class="rfr_input-wrapper">
  <ion-item
    lines="none"
    class="rfr_ion-item"
    [ngClass]="{
      'rfr_ion-item': !readonly,
      'rfr_ion-item_read-only': readonly,
      'rfr_ion-item_error': validate()
    }"
  >
    <ion-select
      labelPlacement="floating"
      [placeholder]="placeholder"
      (ionBlur)="onBlur()"
      [value]="controlDir?.control?.value"
      [readonly]="readonly"
      [disabled]="readonly"
      (ionChange)="!readonly && onChangeInput($event)"
    >
      <ion-label class="rfr-label-text" [class.required]="required" slot="label">
        {{ labelText }}
      </ion-label>
      <ion-select-option
        *ngFor="let item of options"
        [value]="optionValue === 'full' ? item : item.value"
      >
        {{ item.name }}
      </ion-select-option>
    </ion-select>
  </ion-item>
  <ng-content select="[slot=error-message]"></ng-content>
</div>
